import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

import IconOpen from '@/assets/icons/ic-button-open.svg';

export const DropdownWrapper = styled.div``;

export const Dropdown = styled.select`
  width: 100%;
  height: 32px;
  font-size: 14px;
  padding: 0 12px;
  margin: 0;
  box-sizing: border-box;
  color: ${colors.gray800};
  border: 1px solid ${colors.gray200};
  background-color: ${colors.gray100};
  border-radius: 8px;
  outline: none;
  appearance: none;

  background-image: url(${IconOpen});
  background-repeat: no-repeat;
  background-position: calc(100% - 6px) center;
`;
